module.exports = __webpack_public_path__ + "static/media/YM04_3.418006da.jpg";